import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';


export const StyledDashboardLayout = styled(Box)(() => ({
  '.pageTitle': {
    'h1': {
      fontSize: '26px',
      lineHeight: '36px',
      fontWeight: '600',
      color: '#363434',
    }
  },
  '.btnWrap': {
    backgroundColor: "#3F30FF",
    borderRadius: "10px",
    padding: "8px 15px",
    '.addBtn': {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '600',
      color: "#fff",
      padding: "0",
      'svg': {
        marginRight: "5px",
      }
    }
  },

  '.rdt_TableHead': {
    '.rdt_TableHeadRow': {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '600',
      color: "#363434",
      background: "#ebeaff",
    }
  },

  '.customCard': {
    boxShadow: "4px 4px 20px 0px #0000001A",
    borderRadius: "10px",
    padding: "10px 18px",
    position: 'relative',
    '::before': {
      content: '""',
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '5px',
      background: '#3F30FF',
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
    },
    '.dataTable': {
      borderRadius: "12px",
      boxShadow: '0px 1px 10px 0px #0000001A',
      '.toggleBtn': {
        padding: "0",
        'svg': {
          fontSize: "50px",
          color: "#28B316",
        }
      }
    },

    '.card-body': {

      'label': {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '600',
        color: "#363434",
      },
      '.form-control': {
        border: "1px solid #52515433",
        borderRadius: "10px",
        boxShadow: "0px 4px 4px 0px #0000000A",
        padding: '10px 15px',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '400',
        color: "#9D9C9C",
        height: "auto",
      },
      '.MuiInputBase-formControl': {
        borderRadius: "10px",
        boxShadow: "0px 4px 4px 0px #0000000A",
        padding: '10px 15px',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '400',
        color: "#9D9C9C",
        height: "auto",
        '.MuiSelect-select': {
          padding: "7.5px 4px 7.5px 5px",
        },
        '.MuiInputBase-input': {
          padding: "7.5px 4px 7.5px 5px",
        },

      },
      '.uploadFile': {
        textAlign: "center",
        borderRadius: "10px",
        border: "1px solid #52515433",
        boxShadow: "0px 4px 4px 0px #0000000A",
        padding: '10px 15px',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '400',
        color: "#363434",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '20px',
        padding: '25px',
        '.uploadLogo': {
          width: "30px",
          margin: "0 auto 10px",
          display: "block",
        },
        '.chooseFile': {
          fontWeight: "600",
          color: "#0B98C5",
        }

      },
      '.commonBox': {
        border: '1px solid #3F30FF4D',
        boxShadow: '4px 4px 20px 0px #0000001A',
        padding: "20px",
        borderRadius: "10px",
        marginBottom: "20px",
        'h6': {
          fontSize: '20px',
          lineHeight: '30px',
          fontWeight: '600',
          color: "#363434",
          marginBottom: "20px",
        }
      },

      '.addFieldBtn': {
        backgroundColor: "#3F30FF",
        color: "#fff",
        borderRadius: "10px",
        padding: "10px",
        marginTop: "35px",
      },
      '.deleteFieldBtn': {
        backgroundColor: "#d32f2f",
        color: "#fff",
        borderRadius: "10px",
        padding: "10px",
        marginTop: "35px",
      },
    },
    '.commonBtn': {
      backgroundColor: "#3F30FF",
      borderRadius: "10px",
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '600',
      color: "#fff",
      padding: "10px 50px",
    },
    '.backBtn': {
      backgroundColor: "#3F30FF",
      borderRadius: "10px",
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '600',
      color: "#fff",
      padding: "10px 50px",
      ':disabled': {
        cursor: "not-allowed",
        pointerEvents: "none",
        border: "1px solid #ddd",
        backgroundColor: "#FFF",
        color: "#9D9C9C",
      }
    },
    '.stepCard': {
      boxShadow: "none",
      '.addFieldBtn': {
        backgroundColor: "#3F30FF",
        color: "#fff",
        borderRadius: "10px",
        padding: "10px 0",
        marginTop: "0",
        minWidth: "50px",
        '.MuiButton-startIcon': {
          margin: "0"
        }
      },
      '.deleteFieldBtn': {
        backgroundColor: "#d32f2f",
        color: "#fff",
        borderRadius: "10px",
        padding: "10px 0",
        marginTop: "0",
        minWidth: "50px",
        '.MuiButton-startIcon': {
          margin: "0"
        }
      },
    },
  },
  '.content-wrapper': {
    backgroundColor: "#fff",
    '.cardBox': {
      'h6': {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: "600",
        coloe: "#64748B",
      },
      'h3': {
        fontSize: "28px",
        lineHeight: "38px",
        fontWeight: "700",
        coloe: "#363434",
      }
    },
    '.graphBox': {
      backgroundColor: "#fff",
      borderRadius: "10px",
      boxShadow: "4px 4px 20px 0px #0000001A",
      padding: "20px",
      marginTop: "10px",
      'h6': {
        fontSize: '20px',
        lineHeight: '30px',
        fontWeight: '600',
      },
      '.MuiOutlinedInput-input': {
        padding: '0',
      },
      '.modalBtn': {
        backgroundColor: "#3F30FF",
        borderRadius: "10px",
        fontSize: '12px',
        lineHeight: '18px',
        fontWeight: '600',
        color: "#fff",
        padding: "6px 10px",
        textTransform: 'none',
        ':hover': {
          backgroundColor: "#3F30FF",
        }
      }
    }
  },
  '.login-box': {
    width: '400px',
    '.card-header': {
      '.logo': {
        width: '180px',
      }
    },
    '.card-body': {
      padding: '0 15px',
      '.commonBtn': {
        padding: '10px 0',
        width: '100%',
        fontSize: '14px',
        lineHeight: '20px',
        marginTop: '20px',
      }
    }

  }
}));

export default StyledDashboardLayout;

